
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3.632 16V5.204H.202V16h3.43zM1.918 3.73c1.196 0 1.94-.829 1.94-1.865C3.836.805 3.114 0 1.941 0 .767 0 0 .806 0 1.865 0 2.901.744 3.73 1.895 3.73h.023zM5.53 16h3.43V9.972c0-.323.022-.646.112-.876.248-.645.812-1.312 1.76-1.312 1.24 0 1.737.99 1.737 2.44V16H16V9.81c0-3.316-1.692-4.859-3.948-4.859-1.85 0-2.663 1.082-3.114 1.819h.022V5.204H5.53C5.576 6.217 5.53 16 5.53 16z","fill":"#fff"}})])
          )
        }
      }
    